<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>プラスの氣 受信BOX</template>
      <template v-slot:annotation>あなたが受け取ったプラスの氣の一覧 </template>
    </PageHeader>

    <div class="text-center px-3">
      <v-row>
        <DatePicker v-model="searchForm.dateFrom" label="表示開始日" />
        <DatePicker v-model="searchForm.dateTo" label="表示終了日" />

        <v-col>
          <Button @click="get_comment(true)" color="primary">絞り込み</Button>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card-subtitle class="text-right"
            >プラスの氣は「{{ searchNum }}」件です。</v-card-subtitle
          >
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            @click:row="onClickOpen"
            :loading="loading"
            loading-text="読み込み中..."
            no-data-text="プラスの氣受信一覧は見つかりませんでした。表示期間を再確認してください。"
          >
            <template v-slot:[`item.SHOW_SEND_TIME`]="{ item }">
              <YearMonthDay
                :value="item.SHOW_SEND_TIME"
                format="YYYY/MM/DD HH:mm"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <detail ref="detail" @detail="get_comment(false)"></detail>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import { getCurrentDay, getFromDay, format } from '@/utils/day.js';
import { generateMessage } from '@/utils/common.js';
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import detail from '@/components/pages/Encouragements/DetailDialog.vue';
import {
  getSessionStorageItem,
  makeDateTimeStr,
  substr,
  makeDateFormatStr,
} from '../../../common.js';
export default {
  components: {
    detail,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'プラスの氣 受信BOX',
          route: 'EncouragementsRecieveList',
        },
      ],

      // 変数宣言
      showContent: false,
      loading: false,
      searchNum: 0,

      // パラメータ
      userId: '',
      sessionId: '',
      organizationName: '',
      userName: '',
      positionName: '',
      searchForm: {
        dateFrom: '',
        dateTo: '',
      },
      // 自分自身のプラスの氣取得
      items: [],
      headers: [
        {
          text: '日時',
          align: 'left',
          sortable: true,
          value: 'SHOW_SEND_TIME',
          width: '15%',
        },
        {
          text: '送信者',
          align: 'left',
          sortable: true,
          value: 'SEND_USER_NAME',
          width: '20%',
        },
        {
          text: '内容',
          align: 'left',
          sortable: false,
          value: 'SHOW_SUBTITLE',
          width: '46%',
        },
        {
          text: 'いいね!',
          align: 'left',
          sortable: true,
          value: 'NICE_COUNT',
          width: '9%',
        },
      ],
    };
  },
  created() {
    this.initializeSearchForm();

    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
  },

  mounted() {
    this.get_comment(true);
  },

  methods: {
    onClickOpen(item) {
      this.$refs.detail.open(item);
    },

    get_comment(search_flg) {
      this.loading = true;
      this.items = [];

      if (this.userInfo.SESSION_ID === null) {
        return this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
      }

      // 日付From Toチェック
      if (
        makeDateTimeStr('S', this.searchForm.dateFrom) >
        makeDateTimeStr('E', this.searchForm.dateTo)
      ) {
        this.$refs.dialog.open('error', message.MSG_WARN_DATE_ERROR);

        return this.initializeSearchForm();
      }

      // 件数初期化
      this.searchNum = 0;

      //----- プラスの氣取得(ユーザ自身)リクエストGET
      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/myselfComments/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            makeDateTimeStr('S', this.searchForm.dateFrom) +
            '/' +
            makeDateTimeStr('E', this.searchForm.dateTo) +
            '/' +
            config.PURASUNOKI_SEARCH_RECV
        )
        .then((response) => {
          // プラスの氣データ取得
          this.items = response.data;

          // 表示データ整形
          this.searchNum = 0;
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].SEND_USER_AVATER =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              this.items[i].SEND_USER_AVATER +
              '?' +
              format('YYYYMMDDHHmmss');
            this.items[i].TO_USER_AVATER =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              this.items[i].TO_USER_AVATER +
              '?' +
              format('YYYYMMDDHHmmss');
            this.items[i].SHOW_SUBTITLE = substr(
              this.items[i].SEND_COMMENT,
              33,
              '...'
            );
            if (this.items[i].NICE_COUNT == 0) {
              this.items[i].NICE_COUNT = '';
            }
            this.items[i].SEND_START_WORKING_AT = makeDateFormatStr(
              this.items[i].SEND_START_WORKING_AT,
              '/',
              '/',
              ''
            );
            this.items[i].TO_START_WORKING_AT = makeDateFormatStr(
              this.items[i].TO_START_WORKING_AT,
              '/',
              '/',
              ''
            );
            this.searchNum++;
          }

          // 検索結果が最大件数のメッセージ
          if (search_flg) {
            if (this.searchNum == config.PURASUNOKI_MAX_NUM) {
              let infoStr = message.MSG_INFO_PURASUNOKI_LIST_MAX;
              let infoStrReplace = infoStr.replace(
                /a/g,
                config.PURASUNOKI_MAX_NUM
              );
              this.$refs.dialog.open('info', infoStrReplace);
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;

          if (error.response.status == 404) {
            return this.$refs.dialog.open(
              'info',
              generateMessage(message.NOT_FOUND, ['プラスの氣'])
            );
          }
          if (error.response.status == 400) {
            return this.$refs.dialog.open(
              'error',
              message.MSG_ERROR_SESSION + error
            );
          } else {
            return this.$refs.dialog.open(
              'error',
              message.MSG_ERROR_SYTEM + error
            );
          }
        });
    },

    initializeSearchForm() {
      this.searchForm.dateFrom = getFromDay(1);
      this.searchForm.dateTo = getCurrentDay();
    },
  },
};
</script>
